import React, { useContext } from 'react'
import { InitializeContext } from '../App';

export default function Footer() {
          const { theme } = useContext(InitializeContext);
          return (
                    <footer className={`pb-[8rem] pt-10 md:pt-0 md:pb-5 text-center flex flex-col justify-center items-center h-12 ${theme ? 'text-white bg-[#212428] border-[#212428]' : 'bg-[#ECF0F3] text-black border-[#ECF0F3]'}`}>
                              <p className='text-sm px-4 md:px-0'>&copy; Copyright {new Date().getFullYear()} | <span className={`${theme ? 'hover:text-warning' : 'hover:text-primary'} duration-300 cursor-pointer font-semibold`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Toufiq Hasan Kiron</span></p>
                              <p className='text-sm px-4 md:px-0'>All Rights Reserved.</p>
                    </footer>
          )
}
